import { createSelector } from 'reselect';
export var selectMetricState = function (state) { return state.get('metric'); };
export var selectAvarageWaitingTime = createSelector(selectMetricState, function (metricState) { return metricState.get('avarageWaitingTime'); });
